<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item label="分类名称:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.className" placeholder="请输入一级分类名称"></el-input>
							</el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="editialogVisible('',1)">新增一级分类
							</el-button>
							<el-button type="primary" @click="editialogVisible('',2)">新增二级分类
							</el-button>
							<el-button type="primary" @click="editialogVisible('',3)">新增三级分类
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="goodsClassList.list" style="width: 100%" row-key="id" :header-cell-style="headClass" border lazy
			:tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-loading="loading" element-loading-text="拼命加载中">
			<el-table-column prop="storeName" label="商家名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="className" label="分类名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderIndex" label="排序级别" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="image" label="分类图标" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.image" :src="scope.row.image"
						@click="dialogImageUrl=scope.row.image;dialogVisibleImg=true;" width="50px" />
					<div v-else>暂无图标</div>
				</template>
			</el-table-column> -->
			<!-- <el-table-column prop="isShow" label="是否显示" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isShow">是</p>
					<p v-else>否</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="createTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<!-- <el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id,'')">编辑</el-button>
				</template>
			</el-table-column> -->
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="goodsClassList.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="goodsClassList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog :closeOnClickModal="false" title="提示" :visible.sync="showContentDialog" width="50%">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="editDialogVisible" width="50%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">

					<el-form-item v-if="form.level>=2" label="一级分类:">
						<el-select clearable v-model="classGoods1Id" placeholder="请选择一级分类" style="width:200px;margin-right:10px;"
							@change="classGoods1">
							<el-option clearable v-for="item in classGoods1List" :key="item.id" :label="item.className"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item v-if="form.level==3" label="二级分类:">
						<el-select clearable v-model="classGoods2Id" placeholder="请选择二级分类" style="width:200px;margin-right:10px;"
							@change="classGoods2">
							<el-option v-for="item in classGoods2List" :key="item.id" :label="item.className" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="分类等级:">
						<div>{{form.level}}</div>
					</el-form-item>

					<el-form-item label="商品分类名:">
						<el-input v-model="form.className" style="width: 260px;" placeholder="请输入商品分类名" />
					</el-form-item>

					<el-form-item label="分类图标:">
						<el-upload class="upload-demo" :action="imgUrl" :on-preview="handlePreview" :show-file-list="false"
							:on-success="onSuccess" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
							:on-exceed="handleExceed" :file-list="fileList">
							<el-button size="small" type="primary">点击上传</el-button>
							<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
						</el-upload>
					</el-form-item>

					<el-form-item label="图标:">
						<img v-if="form.image" :src="form.image" @click="dialogImageUrl=form.image;dialogVisibleImg=true;"
							width="100px" />
						<div v-else>请上传图片</div>
					</el-form-item>

					<el-form-item label="排序级别:">
						<el-input type="text" style="width: 260px;" oninput="value=value.replace(/[^0-9.]/g,'')" size="small"
							v-model="form.orderIndex" placeholder="请输入数字" />
					</el-form-item>

					<!-- <el-form-item label="是否显示:" class="redItem">
						<el-switch v-model="form.isShow" :active-value="1" :inactive-value="0">
						</el-switch>
					</el-form-item> -->

					<el-form-item>
						<el-button :loading="loading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('goodsclass');

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: "",
				classGoods1Id: 0,
				classGoods2Id: 0,
				classGoods1List: [],
				classGoods2List: [],
				imgUrl: urls,
				dialogVisibleImg: false,
				dialogImageUrl: '',
				fileList: [],
				loading: false,
				goodsClassList: [], //商品分类列表
				dialogVisible: false,
				editDialogVisible: false,
				form: {
					id: 0,
					className: "",
					level: "",
					isShow: "",
					image: "",
					orderIndex: 0,
					pid: 0
				},
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				integralList: [],
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					// level: 1,
					className: this.searchInfo.className
				}
				this.$api.findGoodsClassInfoOffline(data).then((res) => { //商品分类列表
					console.log(res);
					if (res.state == 'success') {
						this.goodsClassList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//选中一级分类
			classGoods1(e) {
				this.classGoods2Id = "";
				if (e) {
					if (this.form.level != 3) {
						this.form.level = 2;
						this.form.pid = e;
						console.log(e)
						console.log(this.form)
					}

					this.$api.goodsClassfindByPid(e).then((res) => { //商品二级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				if (e) {
					this.form.pid = e;
					this.form.level = 3;
				}
				console.log(e)
				console.log(this.form.pid)

			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				console.log(response);
				var form = {
					id: this.form.id,
					className: this.form.className,
					level: this.form.level,
					isShow: this.form.isShow,
					image: response.data,
					orderIndex: this.form.orderIndex,
					pid: this.form.pid
				}
				this.form = form;
			},
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//编辑弹框
			editialogVisible(id, level) {
				this.fileList = []

				//下拉框赋空值
				this.classGoods1Id = "";
				this.classGoods2Id = "";
				this.classGoods2List = [];

				this.form = {
					id: null,
					className: "",
					level: "",
					isShow: "",
					image: "",
					orderIndex: 0,
					pid: 0
				};

				if (id) {
					this.title = '编辑';

					this.fileList = []
					//编辑查询
					this.ids = id
					this.form.timer = []

					this.$api.findByGoodsClassId(id).then((res) => { //根据id查询商品分类
						if (res.state == 'success') {
							this.form = res.data;

							if (res.data.level == 2) {//二级分类
								this.classGoods1Id = res.data.pid;

							} else if (res.data.level == 3) {//三级分类
								this.classGoods2Id = res.data.pid;

								this.$api.findByGoodsClassId(res.data.pid).then((res) => {
									if (res.state == 'success') {
										this.classGoods1Id = res.data.pid;

										this.$api.goodsClassfindByPid(res.data.pid).then((res) => { //商品二级分类
											if (res.state == 'success') {
												this.classGoods2List = res.data;
											}
										})
									} else {
										this.$message.error(res.message);
									}
								})


							}

						}
					})
				} else {
					this.ids = ""
				}

				if (level) {
					this.form.level = level;
					if (level == 1) {
						this.title = '添加一级分类';
					} else if (level == 2) {
						this.title = '添加二级分类';
					} else if (level == 3) {
						this.title = '添加三级分类';
					}
				}

				this.editDialogVisible = true;
			},
			toEdit() {
				if (this.ids) {
					//编辑
					this.$api.editGoodsClass(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.findGoodsClassInfo(); //分类列表刷新
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					//添加
					this.loading = true
					console.log(this.form.pid)
					console.log(this.form)
					this.$api.addGoodsClass(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.findGoodsClassInfo();
						} else {
							this.$message.error(res.message);
						}
						this.loading = false
					})
				}
			},
			pageChange(data) {
				this.page.pageNum = data
				this.findGoodsClassInfo();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findGoodsClassInfo()
			},
			findGoodsClassInfo() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					// level: 1
				}
				this.$api.findGoodsClassInfoOffline(data).then((res) => { //商品分类列表
					console.log(res);
					if (res.state == 'success') {
						this.goodsClassList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			goodsClassfindByPid(row, expanded) {
				console.log(row, expanded);
				//this.loading2 = true
				this.$api.goodsClassfindByPid(row.id).then((res) => { //根据pid查询商品分类
					console.log(res);
					if (res.state == 'success') {
						this.goodsClassList2 = res.data
						//this.loading2 = false
					} else {
						this.$message.error(res.message);
					}
				})
			}
		},
		created() {
			this.findGoodsClassInfo();
			// this.$api.goodsClassfindByPid(0).then((res) => { //商品一级分类
			// 	if (res.state == 'success') {
			// 		this.classGoods1List = res.data;
			// 	}
			// })
		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>